import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {useEffect} from 'react';

import {RootState} from '../../../index';
import {getMyTop10GamesState} from '../../../selectors/fortnite-game/myTop10GamesSelector';
import {
    MyTop10GamesState,
    MyTop10GamesItem
} from '../../../reducers/fortnite-game/myTop10Games.reducer';
import actionsMyTop10Games from '../../../actions/fortnite-game/myTop10Games.actions';

import useGamesData from '../../../pages/fortnite-games/useGamesData';
import {GameDataItem} from '../../../types';

export interface UseMyTop10GamesDataParams {
    category: string | number;
}

const useMyTop10GamesData = ({category}: UseMyTop10GamesDataParams): MyTop10GamesState => {
    const dispatch = useDispatch();

    const {
        data: {codeNamesMap},
        loading
    } = useGamesData();

    const {activePlayers, averagePlayTime, playerRetention, totalLifetimePlays} = useSelector<
        RootState,
        MyTop10GamesState
    >(getMyTop10GamesState, shallowEqual);

    const getMappedGame = (game: GameDataItem): GameDataItem => ({
        ...game,
        label: codeNamesMap[game.creativeIslandCode]
            ? String(codeNamesMap[game.creativeIslandCode])
            : ''
    });

    const getLoading = (loading: boolean, dataItem: MyTop10GamesItem): {loading: boolean} => ({
        loading: loading || dataItem.loading
    });

    useEffect(() => {
        const request = {value: category};

        dispatch(
            actionsMyTop10Games.getMyTop10Games({
                ...request
            })
        );
    }, [category]);

    return {
        activePlayers: {
            ...activePlayers,
            list: activePlayers.list.map(listItem => getMappedGame(listItem)),
            ...getLoading(loading, activePlayers)
        },
        averagePlayTime: {
            ...averagePlayTime,
            list: averagePlayTime.list.map(listItem => getMappedGame(listItem))
        },
        playerRetention: {
            ...playerRetention,
            list: playerRetention.list.map(listItem => getMappedGame(listItem))
        },
        totalLifetimePlays: {
            ...totalLifetimePlays,
            list: totalLifetimePlays.list.map(listItem => getMappedGame(listItem))
        }
    };
};

export default useMyTop10GamesData;
